import { BasicMarks } from '../../../../../editJournal/slateUtilities/plugins';

export default [...BasicMarks];
